module.exports = __webpack_public_path__ + "media/images/icons/hit-default-4497a65c3e432f5269a80f57cedbc599.png";